module.exports = __webpack_public_path__ + "img/4.ee7ed6a2.png";